import { Link } from "react-router-dom";
import { BETA_URL, SITE_DOMAIN } from "../config";

export function Footer() {
  return (
    <footer className="footer wrap">
      <Link to="/" className="brand">
        <span className="dot" />
        KinSafe
      </Link>
      <div className="footer-links">
        <Link to="/demo">Slider demo</Link>
        <Link to="/grade">Grade your PC</Link>
        <Link to="/hardware">Hardware load</Link>
        <Link to={BETA_URL}>Join the beta waitlist</Link>
      </div>
      <span className="mono muted">
        {SITE_DOMAIN} · private &amp; local by construction
      </span>
    </footer>
  );
}
